<template>
    <Translations>
        <Theme>
            <v-style>body {overflow: hidden; }</v-style>
            <slot></slot>
            <CguModal v-if="isCguModalVisible"></CguModal>
            <Edits :datas="datas" @rename-favorite="builder => $emit('rename-favorite', builder)"></Edits>
        </Theme>
    </Translations>
</template>

<script>
import CguModal from "@/components/CguModal/CguModal";
import { mapGetters } from "vuex";
import Theme from "./components/theme";
import Translations from "./components/translations";
import Edits from "./edits";

export default {
    components: { CguModal, Theme, Translations, Edits },
    computed: {
        ...mapGetters("cguStore", {
            isCguModalVisible: "getShown"
        })
    },
    props: {
        datas: {
            type: Object,
            required: false
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/themes";

// override background-color without having to use !important
.dark#app,
.light#app,
#app {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: stretch;
    background-color: rgb(240, 240, 240);
}
</style>



// WEBPACK FOOTER //
// plano-scaffold.vue?a41a54f2